module.exports = __webpack_public_path__ + "img/PGB.fce64129.png";